import React from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ScheduleTableByWeek } from "./schedule/ScheduleTableByWeek";

export const SubjectByStudentApp = ({
    showHeaderStudentCol = false,
    showHeaderCycleCol = false,
    forceHideTeacher = false,
    compact = false
}) => {
    const { response, active } = useSelector(
        (state) => state.subjectsByStudentApp
    );
    const { session } = useSelector((state) => state.auth);

    return (
        <>
            {/* Si no se muestra el horario arriba de la tabla */}
            {(showHeaderStudentCol || showHeaderCycleCol) && (
                <Row className="w-100">
                    {showHeaderStudentCol && (
                        <Col md={12}>
                            <h4
                                className="me-4"
                                academic_record_id={active?.academic_record?.id }
                            >
                                {`Alumno: ${active?.academic_record?.student_number} - ${active?.academic_record?.student?.full_name}`}
                            </h4>
                        </Col>
                    )}

                    {showHeaderCycleCol && (
                        <Col md={12}>
                            <h6
                                cycle_id={response?.cycle?.id}
                                className="mb-4"
                            >{`Ciclo: ${response?.cycle?.name}`}</h6>
                        </Col>
                    )}
                </Row>
            )}
            <Row>
                <Col md={12}>
                    <ScheduleTableByWeek
                        name={
                            session === "operator"
                                ? "STUDENT_SUBJECTS"
                                : session === "teacher"
                                ? "TEACHER_SCHEDULE_SESSION"
                                : "STUDENT_SCHEDULE_SESSION"
                        }
                        schedules={response?.schedules}
                        academic_group={null}
                        session={session}
                        showAcademicGroup={["teacher", "operator"].includes(session)}
                        showTeacher={
                            forceHideTeacher ? false : session !== "teacher"
                        }
                        compact={compact}
                    />
                </Col>
            </Row>
        </>
    );
};
